import React, { useMemo, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoginBcgImage from "../../assets/images/bg-login.png";
import BgForgotImage from "../../assets/images/forgot-bg.png";
import backIcon from "../../assets/icons/back.svg";
import Welcome from "../../common/components/welcome/welcome";
import "../login/login.scss";
import { NavLink, useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import * as resetPasswordAPI from "../../api/resetpassword";
import { useSetLoading } from "../../common/hooks/appearance";
import "./forgot-password.scss";

const ForgotPassword: React.FC = () => {
  const [message, setMessage] = useState<{
    message: string;
    types: string;
  } | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const initialValues = { username: "" };

  const validationSchema = Yup.object({
    username: Yup.string().required("Username is required"),
  });

  const onSubmit = async (values: typeof initialValues) => {
    setIsLoading(true);
    try {
      const response: any = await resetPasswordAPI?.forgotpassword(values);
      if (response?.data?.data?.message) {
        setMessage({
          message: response?.data?.data?.message,
          types: "success",
        });
      }
      setIsLoading(false);
    } catch (error: any) {
      setMessage({
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Something went wrong!",
        types: "error",
      });
      setIsLoading(false);
    }
  };

  const showLoading = useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);

  return (
    <div
      className="login-page-wrapper"
      style={{
        backgroundImage: `url(${BgForgotImage}), url(${LoginBcgImage})`,
        backgroundRepeat: "no-repeat, no-repeat",
        backgroundPosition: "center bottom, center bottom",
        backgroundSize: "100% 40%, 100% 40%",
      }}
    >
      <div className="login-card-wrapper">
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {() => (
              <Form className="loginForm forgotpassword-wrapper">
                <div className="back-icon-wraper">
                  <NavLink to={routes.LOGIN}>
                    <img src={backIcon} alt="back" />
                    <span>Back to Login</span>
                  </NavLink>
                </div>
                <h2>Forgot Password</h2>
                <div className="formBody">
                  <div className="field">
                    <Field
                      type="text"
                      name="username"
                      placeholder="Username *"
                    />
                    <ErrorMessage
                      name="username"
                      component="div"
                      className="errorMessage"
                    />
                  </div>

                  <button type="submit" className="submitButton">
                    {isLoading ? "Sending..." : "Send Reset Link"}
                  </button>

                  {message?.message && (
                    <div
                      className={`${
                        message?.types === "error"
                          ? "login-error-message"
                          : "login-success-message"
                      } message-container`}
                      style={{ marginTop: "10px", textAlign: "center" }}
                    >
                      {message?.message}
                    </div>
                  )}

                  <div className="or-wrapper">
                    <hr />
                  </div>
                  <div className="description-item">
                    <span>
                      In case of any issues, please{" "}
                      <span
                        className="contact-header"
                        onClick={() => {
                          navigate(routes.CONTACT_US);
                        }}
                      >
                        Contact Us
                      </span>
                    </span>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="right-content-wraper">
          <Welcome />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
